import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=5ae09691&scoped=true&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&id=5ae09691&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae09691",
  null
  
)

export default component.exports